{
  "title": "Picking Management",
  "subtitle": "Assign, scan, and complete pick lists generated from approved material requests.",
  "open": "Open",
  "table": {
    "number": "Pick List #",
    "mr": "Material Request",
    "warehouse": "Warehouse",
    "assignedTo": "Assigned To",
    "lines": "Lines",
    "status": "Status"
  },
  "dialog": {
    "assignTo": "Assign To",
    "assign": "Assign",
    "lines": "Pick Lines",
    "suggested": "Suggested",
    "requested": "Requested",
    "barcode": "Barcode",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan or type this line's barcode to confirm you're picking the physical unit in hand.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "scanned": "Scanned",
    "expectedBarcode": "Barcode to Scan: {{barcode}}",
    "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this item has no barcode or printed label — assign a Material barcode or print labels before picking.",
    "pickedQty": "Picked Qty",
    "savePicks": "Save Picks",
    "complete": "Complete & Update Stock"
  },
  "cancel": "Cancel"
}
